import { SortDirection } from '@Pages/RetroSynthesis/constants';

export function getSortDirectionText(direction, fallback = 'descending') {
  const normalizedDirection = direction?.toLowerCase?.();

  if (normalizedDirection === SortDirection.ASC.toLowerCase()) {
    return 'ascending';
  }

  if (normalizedDirection === SortDirection.DESC.toLowerCase()) {
    return 'descending';
  }

  return fallback;
}

export function getAriaSortFromSortList(sortList, sortParam) {
  const direction = sortList?.find((item) => item?.property === sortParam)?.direction;
  return getSortDirectionText(direction, 'none');
}
